/* Feature composites: layered screenshots that assemble when scrolled into
   view. Used by the key-features blocks (video-blocks.ejs) on every page
   that includes them, so unlike scroll-reveal.js this does not bail outside
   the homepage. Motion lives in CSS (.composite .layer in main.scss); this
   file only flips .assembled. Reduced motion assembles everything up front. */
(function () {
  var composites = document.querySelectorAll('.composite');
  if (!composites.length) return;

  function assembleAll() {
    composites.forEach(function (el) {
      el.classList.add('assembled');
    });
  }

  if (
    !('IntersectionObserver' in window) ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    assembleAll();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('assembled');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.25, rootMargin: '0px 0px -5% 0px' }
  );

  composites.forEach(function (el) {
    /* Already scrolled past (restored scroll position): show immediately. */
    if (el.getBoundingClientRect().bottom < 0) {
      el.classList.add('assembled');
      return;
    }
    observer.observe(el);
  });
})();
